<template>
    <div v-if="selectedHorse?.id != null" class="horse-preview flex flex-column py-4 px-2 gap-4">
        <HorsePreviewMainData :selectedHorse="selectedHorse" @delete-element="$emit('delete-element')"/>
        <HorsePreviewDates :selectedHorse="selectedHorse"/>
        <div class="separator"/>
        <HorsePreviewOwners :selectedHorse="selectedHorse"/>
        <div class="separator"/>
        <HorsePreviewPedigree :selectedHorse="selectedHorse"/>
        <div class="separator"/>
        <HorsePreviewStudbooks :selectedHorse="selectedHorse"/>
        <div class="separator"/>
        <HorsePreviewOtherData :selectedHorse="selectedHorse"/>
    </div>
</template>

<script>
import HorsePreviewMainData from "@/views/horse/horseList/components/HorsePreviewMainData.vue";
import HorsePreviewDate from "@/views/horse/horseList/components/HorsePreviewDate.vue";
import HorsePreviewDates from "@/views/horse/horseList/components/HorsePreviewDates.vue";
import HorsePreviewOwners from "@/views/horse/horseList/components/HorsePreviewOwners.vue";
import HorsePreviewPedigree from "@/views/horse/horseList/components/HorsePreviewPedigree.vue";
import HorsePreviewStudbooks from "@/views/horse/horseList/components/HorsePreviewStudbooks.vue";
import HorsePreviewOtherData from "@/views/horse/horseList/components/HorsePreviewOtherData.vue";

export default {
    name: "HorsePreview",
    components: {
        HorsePreviewOtherData,
        HorsePreviewStudbooks,
        HorsePreviewPedigree,
        HorsePreviewOwners,
        HorsePreviewDates,
        HorsePreviewDate,
        HorsePreviewMainData,
    },

    props: {
        selectedHorse: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
        };
    },

    emits: ["delete-element"],
};
</script>

<style lang="scss">
@import "../../../../assets/theme/mytheme/variables";
.horse-preview {
    .separator {
        width: 100%;
        height: 1.5px;
        background-color: var(--separator-color);
    }
}
</style>
